import JobtitlesService from '@/api/JobtitlesService.js'
import Vue from 'vue'
export const jobtitlesModule = {
  namespaced: true,
  state: () => ({
    jobtitlesData: [],
    jobtitlesLoadStatus: 'request',
    paginationJobtitlesStateParams: {
      count: 0,
      limit: 5,
      total: 0,
      page: 0
    }
  }),

  getters: {
    numPages: (state) =>
      Math.ceil(
        state.paginationJobtitlesStateParams.total /
        state.paginationJobtitlesStateParams.limit
      )
  },
  mutations: {
    get_all(state, data) {
      state.jobtitlesData = [...data]
    },
    create(state, data) {
      state.jobtitlesData.unshift(data[0])
    },
    edit_multiple(state, data) {
      let indexed = state.jobtitlesData.findIndex(
        (x) => x.jobtitles__id == data.id
      )
      Object.assign(state.jobtitlesData[indexed], data.dataEdit)
    },

    delete_data(state, id) {
      let indexed = state.jobtitlesData.findIndex((x) => x.jobtitles__id == id)

      state.jobtitlesData.splice(indexed, 1)
    },

    update_pagination(state, { total, count, limit, page }) {
      state.paginationJobtitlesStateParams = { total, count, limit, page }
    },

    load_request(state, status) {
      state.jobtitlesLoadStatus = 'request'
    },
    load_success(state) {
      state.jobtitlesLoadStatus = 'success'
    },
    load_error(state) {
      state.jobtitlesLoadStatus = 'error'
    }
  },
  actions: {
    getJobtitlesAll({ commit }, params) {
      commit('load_request')
      JobtitlesService.getAll(params)
        .then((data) => {
          commit('update_pagination', data.data.data)
          commit('get_all', data.data.data.rows)
          commit('load_success')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
          commit('load_error')
        })
    },

    createJobtitlesData({ commit }, createData) {
      JobtitlesService.create(createData)
        .then((data) => {
          commit('create', data.data.data.rows)
          Vue.$toast.success('Запись добавлена')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
        })
    },

    editJobtitlesMultiple({ commit }, { id, dataEdit }) {
      JobtitlesService.editMultiple(id, dataEdit)
        .then((data) => {
          commit('edit_multiple', { id, dataEdit })
          Vue.$toast.success('Данные успешно обновлены')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
        })
    },

    deleteJobtitlesData({ commit }, id) {
      // commit("load_request");
      JobtitlesService.delete(id)
        .then((data) => {
          commit('delete_data', id)
          Vue.$toast.success('Данные успешно удалены')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
        })
    }
  }
}
